export enum ProgressValueType {
  Steps = "steps",
  Kilometers = "kilometers",
}
